import React from 'react';
import { UxIcon } from '@lwt-helix/core';

const EmailValidationNotification = ({ notification }) => {
  switch (notification) {
    case "invalid":
      return (
        <p className="border-top text-danger mt-4 pt-3"
          data-lwt-id="email-validation-notification-invalid">
          <UxIcon className="mr-2" iconName="warning" />
          You have entered an invalid email address
        </p>
      );
    case "existing":
      return (
        <p className="border-top text-warning mt-4 pt-3"
          data-lwt-id="email-validation-notification-existing">
          <UxIcon className="mr-2" iconName="warning" />
          You have entered a user who already has a Lone Wolf Account
        </p>
      );
    case "notRosterMember":
      return (
        <p className="border-top text-warning mt-4 pt-3"
          data-lwt-id="email-validation-notification-notRosterMember">
          <UxIcon className="mr-2" iconName="warning" />
        Inviting a user here does not add that employee to Lone Wolf Back Office. You will need to add this user to Back Office separately.
        </p>
      );
    case "sendConfirmation":
      return (
        <p className="border-top text-center text-warning pt-5 h2"
          data-lwt-id="email-validation-notification-sendConfirmation">
          <UxIcon className="h1" iconName="warning" />
          <br />
        An entered email address could not be found in the brokerage roster. Are you sure you would like to send the invite?
        </p>
      );
    default:
      return null;
  }
};

const SendInviteNotification = ({ notification }) => {
  switch (notification) {
    case "success":
      return (
        <p className="text-center text-success mt-4 pt-3"
          data-lwt-id="email-validation-notification-invalid">
          Your invite has been sent
        </p>
      );
    case "fail":
      return (
        <p className="text-center text-danger mt-4 pt-3"
          data-lwt-id="email-validation-n otification-invalid">
          There was an issue sending your invite.
          <br />
          Please try again or contact your system administrator.
        </p>
      );
    default:
      return null;
  }
};

export { EmailValidationNotification, SendInviteNotification };
